export function getDealInfo() {
  const cookies = document.cookie
    .split(';')
    .map((cookie) => cookie.trim().split('='));
  const [discountData, dealerUserData] = [
    'dealerdiscount',
    'dealerusername',
  ].map((key) => cookies.find((cookie) => cookie[0] === key));

  if (!discountData || !dealerUserData) return;
  const discountNum = Number(discountData[1]);
  const dealerUserName = dealerUserData[1];
  if (Number.isNaN(discountNum) || discountNum < 0 || discountNum > 100)
    return console.warn('Invalid discount');
  if (!dealerUserName) return console.warn('Invalid dealer user name');
  return { discount: discountNum / 100, dealerUserName };
}



// WEBPACK FOOTER //
// ./src/helper/dealer.js